import InvitePage from "./InvitePage";
export default InvitePage;
